import { EventNames } from "src/core/analytics/dataMesh/common/enums";

export const WEB_LOCK_WHITELIST = [
  EventNames.MARKETING_CLIENT_FIRST_LANDING,
  EventNames.MARKETING_CLIENT_FIRST_VISIT,
];
